var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    color: "#5A5F60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.6667C1.5 10.6667 1.6011 11.3744 4.53003 14.3033C7.45897 17.2322 12.2077 17.2322 15.1366 14.3033C16.1744 13.2656 16.8444 11.9994 17.1468 10.6667M1.5 10.6667V15.6667M1.5 10.6667H6.5M18.1667 7.33333C18.1667 7.33333 18.0656 6.62563 15.1366 3.6967C12.2077 0.767767 7.45897 0.767767 4.53003 3.6967C3.4923 4.73443 2.82225 6.0006 2.51986 7.33333M18.1667 7.33333V2.33333M18.1667 7.33333H13.1667",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.75950518c372cb698c96aaab23eeef1f.svg";
export { ForwardRef as ReactComponent };